import { Injectable, Inject, DOCUMENT } from '@angular/core';

declare var $: any;
@Injectable({
  providedIn: 'root'
})

export class CanonicalService {

  constructor(@Inject(DOCUMENT) private dom) { }

  setCanonicalURL(url?: string) {
    const canURL = url === undefined ? this.dom.URL : url;
    if ($('link[rel=canonical]').length === 0) {
      const link: HTMLLinkElement = this.dom.createElement('link');
      link.setAttribute('rel', 'canonical');
      this.dom.head.appendChild(link);
      link.setAttribute('href', canURL);
    } else {
      $('link[rel=canonical]').attr('href', canURL);
    }
  }

  getCanonicalURL() {
    return  this.dom.URL;
  }

}
